import ScheduledRemindersForm from './ScheduledRemindersForm/index';

export default ScheduledRemindersForm;